
import Vue from 'vue';
// import VueRouter, { RouterOptions, Route } from 'vue-router';
import { EventBus } from '@/plugins/eventBus';
import { i18n, trans } from '@/i18n';
export default Vue.extend({
  name: 'AppMenu',
  data: () => ({
    item: {},
    domain: document.location.origin,
    items: [
      { name: trans('menu.financial'), icon: 'credit_card', to: { name: 'flow', params: { name: 'Financial'}} },
      { name: trans('menu.retail'), icon: 'shopping_cart', to: { name: 'flow', params: { name: 'Shopping' }} },
      { name: trans('menu.gambling'), icon: 'monetization_on', to: { name: 'flow', params: { name: 'Gambling' }} },
      { name: trans('menu.insurance'), icon: 'directions_car', to: { name: 'flow', params: { name: 'Insurance' }} },
      { name: trans('menu.gaming'), icon: 'videogame_asset', to: { name: 'flow', params: { name: 'Gamer' }} },
      // { name: 'PSD2', icon: 'grade', to: { name: 'flow', params: { name: 'PSD2%20Compliance' }} },
      // { name: trans('menu.call_center'), icon: 'contact_support', to: { name: 'flow', params: { name: 'Call%20Center' }} },
      // { name: trans('menu.pub_sector'), icon: 'account_balance', to: { name: 'flow', params: { name: 'Public%20Sector' }} },
      { name: trans('menu.chg_theme'), icon: 'invert_colors', to: { name: 'theme' } },
    ],
  }),
  methods: {
      close() {
        EventBus.$emit('closeDrawer', true);
      },
  },
});
